<template>
  <div class="main">
    <div class="search">
      <el-button size="mini" type="primary" @click="dialogFormVisible = true">新增</el-button>
      <div>
        <!-- 新增 -->
        <el-dialog
          title="新增评论"
          :visible.sync="dialogFormVisible"
          width="650px"
          :close-on-click-modal="false"
        >
          <div class="content">
            <el-form ref="form" :model="form" label-width="120px" size="small" style="width:100%">
              <el-form-item label="店铺名:">
                <el-input type="text" placeholder="请输入内容" v-model="textarea"></el-input>
              </el-form-item>
              <el-form-item label="评论:">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  placeholder="请输入内容"
                  v-model="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="评分:">
                <el-rate v-model="star" class="star"></el-rate>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
            <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="BigContent">
      <div class="itemNav">
        <span>
          <el-checkbox v-model="value"></el-checkbox>
        </span>
        <span>序号</span>
        <span>店铺名</span>
        <span>评论</span>
        <span>评分</span>
        <span>创建时间</span>
        <span>操作</span>
      </div>
      <div class="item" v-for="(item,index) in 6" :key="index" @click="dialogFormVisible2 = true">
        <span>
          <el-checkbox v-model="value"></el-checkbox>
        </span>
        <span>{{ index+1 }}</span>
        <span>{{ "weidouke" }}</span>
        <span>{{ "五星好评五星好评五星好评五星好评五星好评" }}</span>
        <span>
          <el-rate v-model="star" class="star"></el-rate>
        </span>
        <span>{{ '2020-06-04 04:42' }}</span>
        <span>删除</span>
      </div>
      <!-- 分页 -->
      <div class="pag">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="30"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="20"
        ></el-pagination>
      </div>
      <!-- 修改 -->
        <el-dialog
          title="修改评论"
          :visible.sync="dialogFormVisible2"
          width="650px"
          :close-on-click-modal="false"
        >
          <div class="content">
            <el-form ref="form" :model="form" label-width="120px" size="small" style="width:100%">
              <el-form-item label="店铺名:">
                <el-input type="text" placeholder="请输入内容" v-model="textarea"></el-input>
              </el-form-item>
              <el-form-item label="评论:">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  placeholder="请输入内容"
                  v-model="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="评分:">
                <el-rate v-model="star" class="star"></el-rate>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="dialogFormVisible2 = false">确 定</el-button>
            <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
          </div>
        </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      dialogFormVisible2: false,
      textarea: "",
      star: null,
      form: {
        name: ""
      },
      value: ""
    };
  },
  methods: {},
  components: {}
};
</script>

<style lang="less" scoped>
.main {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 237, 248, 1);
  box-sizing: border-box;
  padding: 20px;
  > .nav {
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 50px;
    border-bottom: 1px solid rgba(235, 237, 248, 1);
    padding-left: 20px;
  }
  .oinput {
    width: 300px;
  }
  > .content {
    padding-left: 10%;
    padding-top: 30px;
  }
  .btns {
    text-align: center;
    margin-bottom: 50px;
    margin-top: 20px;
  }
}
// 上传图片
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form-item {
  margin-bottom: 6px;
}
/deep/ .el-upload.el-upload--text {
  border: 1px dashed #e6e6e6;
}
/deep/ .el-rate.star {
  padding-top: 4px;
  height: 27px;
  line-height: 27px;
  box-sizing: border-box;
}
.BigContent {
  .itemNav,
  .item {
    padding-left: 18px;
    &:hover {
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 6%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 18%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 30%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 18%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 10%;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .itemNav {
    margin-bottom: 10px;
    &:hover {
      background-color: #fff;
    }
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    &:hover{
      cursor: pointer;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(7) {
      color: #1980ff;
      > span {
        display: inline;
        color: #1980ff;
        &:hover {
          cursor: pointer;
        }
      }
      > span:nth-child(2),
      > span:nth-child(4) {
        margin: 0 4px;
        color: #e6e6e6;
        &:hover {
          cursor: auto;
        }
      }
      /deep/ .el-dropdown {
        width: 30px;
        span {
          color: #1980ff;
        }
      }
      > .more {
        display: inline;
      }
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
.search {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  > div {
    display: flex;
    > div {
      margin-right: 20px;
    }
  }
  > div:last-child {
    margin-right: 0px;
  }
  .searchInput {
    width: 200px;
    border-radius: 0px;
    /deep/ .el-input__inner {
      border-radius: 4px;
    }
  }
  .searchBtn {
    height: 40px;
    background: rgba(0, 119, 255, 1);
    border-radius: 0px 3px 3px 0px;
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>